import ButtonUpdateSection from './button/button-update-section.component.jsx';
import ContactFormUpdateSection from './contact-form/contact-form-update-section.component.jsx';
import DividerUpdateSection from './divider/divider-update-section.component.jsx';
import ImageSection from './image/image-update-section.component.jsx';
import ParagraphUpdateSection from './paragraph/paragraph-update-section.component.jsx';
import SpacerUpdateSection from './spacer/spacer-update-section.component.jsx';
import SubtitleUpdateSection from './subtitle/subtitle-update-section.component.jsx';
import TitleUpdateSection from './title/title-update-section.component.jsx';
import YouTubeUpdateSection from './youtube/youtube-update-section.component.jsx';
import ProductSlideshowUpdateSection from './product-slideshow/product-slideshow-update-section.component.jsx';

const sectionComponentMap = {
  button: {
    component: ButtonUpdateSection,
    name: 'Button',
    requires: { shop: false }
  },
  contactForm: {
    component: ContactFormUpdateSection,
    name: 'Contact Form',
    requires: { shop: false }
  },
  divider: {
    component: DividerUpdateSection,
    name: 'Divider',
    requires: { shop: false }
  },
  image: {
    component: ImageSection,
    name: 'Image',
    requires: { shop: false }
  },
  paragraph: {
    component: ParagraphUpdateSection,
    name: 'Paragraph',
    requires: { shop: false }
  },
  productSlideshow: {
    component: ProductSlideshowUpdateSection,
    name: 'Product Slideshow',
    requires: { shop: true }
  },
  spacer: {
    component: SpacerUpdateSection,
    name: 'Spacer',
    requires: { shop: false }
  },
  subtitle: {
    component: SubtitleUpdateSection,
    name: 'Subtitle',
    requires: { shop: false }
  },
  title: {
    component: TitleUpdateSection,
    name: 'Title',
    requires: { shop: false }
  },
  youtube: {
    component: YouTubeUpdateSection,
    name: 'YouTube Embed',
    requires: { shop: false }
  }
};

export default sectionComponentMap;